import React from "react";
import UiTag from "../ui/UiTag";

const ReceptionistCountBadge = ({ count }) => {
  if (count == null || count === "") return null;

  return (
    <UiTag tone="info" size="sm">
      {count}
    </UiTag>
  );
};

export default ReceptionistCountBadge;
